import { render, staticRenderFns } from "./bounty.vue?vue&type=template&id=0af5d156&scoped=true&lang=pug&"
import script from "./bounty.vue?vue&type=script&lang=js&"
export * from "./bounty.vue?vue&type=script&lang=js&"
import style0 from "./bounty.vue?vue&type=style&index=0&id=0af5d156&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af5d156",
  null
  
)

export default component.exports